import m from 'mithril';
import { asCurrency } from './format.ts';
import type { Cost } from './types.ts';

interface TableAttrs {
    costs: Cost[];
    /** Opens that term's schedule. Absent in the storybook. */
    onpick?: (term: number) => void;
}

export const Table: m.Component<TableAttrs> = {
    view: ({ attrs: { costs, onpick } }) =>
        m(
            '.table-scroll',
            m(
                'table.data-table',
                m(
                    'thead',
                    m('tr', [
                        m('th', 'Term'),
                        m('th.numeric', 'Monthly cost'),
                        m('th.numeric', 'Loan cost'),
                    ]),
                ),
                m(
                    'tbody',
                    costs.map((cost) =>
                        m('tr', [
                            m(
                                'td',
                                // A button rather than a click handler on the
                                // row: the keyboard reaches it, and it says
                                // that the term is the thing you can open.
                                onpick
                                    ? m(
                                          'button.row-link',
                                          {
                                              type: 'button',
                                              onclick: () => onpick(cost.term),
                                          },
                                          `${cost.term} years`,
                                      )
                                    : `${cost.term} years`,
                            ),
                            m('td.numeric', asCurrency(cost.monthly_cost)),
                            m('td.numeric', asCurrency(cost.loan_cost)),
                        ]),
                    ),
                ),
            ),
        ),
};
